module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


//////////////////
// WEBPACK FOOTER
// external "$GP"
// module id = 21
// module chunks = 1